<template>
  <div>
    <div class="ticketing-steps bg-white border-bottom">
      <div class="container">
        <div class="row">
          <div class="col ticketing-step">
            <div :class="{ 'text-danger': step === 1 }">
              <i class="fe fe-grid"></i>
              <span>{{ this.$root.translate('ticketing.step_seats') }}</span>
            </div>
          </div>
          <div class="col ticketing-step">
            <div :class="{ 'text-danger': step === 2 }">
              <i class="fe fe-shopping-bag"></i>
              <span>{{ this.$root.translate('ticketing.step_consessions') }}</span>
            </div>
          </div>
          <div class="col ticketing-step">
            <div :class="{ 'text-danger': step === 3 }">
              <i class="fe fe-credit-card"></i>
              <span>{{ this.$root.translate('ticketing.step_payment') }}</span>
            </div>
          </div>
          <div class="col ticketing-step">
            <div :class="{ 'text-danger': step === 4 }">
              <i class="fe fe-inbox"></i>
              <span>{{ this.$root.translate('ticketing.step_success') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="header mb-3"></div>

      <div class="row">
        <div class="col-lg-4 col-12 order-sm-last">

          <div class="card card-sm">
            <div class="card-body">
              <div class="row">
                <div class="col" v-if="data.showtime">
                  <p class="text-truncate mb-0">
                    {{ data.showtime.movie?.name }}
                  </p>
                  <p class="text-truncate mb-0">
                    <strong>{{ data.showtime.cinema?.name }}</strong>
                  </p>
                  <p class="text-truncate mb-0">
                    {{ this.$root.translate('ticketing.session_at') }}
                    <strong>
                      {{
                        new Date(data.showtime.time).toLocaleString('vi-VN', {
                          hour: '2-digit',
                          minute: '2-digit',
                          second: undefined,
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric'
                        })
                      }}
                    </strong>
                  </p>
                  <p class="text-truncate mb-0">
                    {{ this.$root.translate('ticketing.screen') }} <strong>{{ data.showtime.room }}</strong>
                    -
                    {{ this.$root.translate('ticketing.seats') }}
                    <span v-if="this.cart.seats.length === 0">...</span>
                    <span class="font-weight-bold" v-for="seat in this.cart.seats">
                      {{ seat.name }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="card d-none d-md-block">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col">
                  <h6 class="card-title text-uppercase text-muted mb-2">
                    {{ $root.translate('ticketing.order_total') }}
                  </h6>
                  <span class="h2 mb-0">
                    {{ new Intl.NumberFormat('vi-VN', {style: 'currency', currency: 'VND'}).format(order.total) }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="flow-actions sticky-footer-bars">
            <div class="row">
              <div class="col-3">
                <a href="#" class="btn btn-lg btn-outline-dark btn-block" :class="{ 'disabled' : step !== 2 }"
                   v-on:click="stepHandler('prev')">
                  &larr;
                </a>
              </div>
              <div class="col-9">
                <a href="#" class="btn btn-lg btn-dark btn-block"
                   :class="{ 'disabled': this.cart.seats.length === 0 || step === 3 }" v-on:click="stepHandler('next')">
                  <span class="d-md-none">{{
                      new Intl.NumberFormat('vi-VN', {
                        style: 'currency',
                        currency: 'VND'
                      }).format(order.total)
                    }} |</span>
                  {{ $root.translate('ticketing.continue') }}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-8 col-12">

          <div class="alert alert-danger" v-if="errors.length > 0">
            <p><strong>Có lỗi xảy ra:</strong></p>
            <ul>
              <li v-for="error in errors">{{ error }}</li>
            </ul>
            <p class="mb-0">
              Vui lòng thử lại hoặc <a href="/support" class="text-white">liên hệ trung tâm hỗ trợ</a>.
            </p>
          </div>

          <div v-if="errors.length === 0">
            <div id="ticketing-step-0" v-if="step === 1">
              <div class="ticketing-content">
                <div class="seat-selection">

                  <div class="legend">
                    <div>
                      <span class="selected"></span>
                      <p>{{ $root.translate('ticketing.your_seats') }}</p>
                    </div>
                    <div>
                      <span class="unavailable"></span>
                      <p>{{ $root.translate('ticketing.unavailable_seats') }}</p>
                    </div>
                    <div>
                      <span class="seat-area-1 taken"></span>
                      <p>{{ $root.translate('ticketing.sold_seats') }}</p>
                    </div>
                  </div>

                  <span class="front">{{ $root.translate('ticketing.seat_screen') }}</span>

                  <div class="text-center" v-if="this.data.seats.rows.length === 0">
                    <div class="spinner-border d-block m-auto" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <p class="text-muted mt-2" v-html="$root.translate('ticketing.skip_tickets')"></p>
                  </div>

                  <div class="seats-wrapper-parent">
                    <div class="seats-wrapper">
                      <div class="seats-wrapper-row">
                        <div class="seats seats-row">
                          <div class="row-wrapper">
                            <ul class="seat-row" v-for="row in data.seats.rows">
                              <li class="rowname wide">{{ row }}</li>
                            </ul>
                          </div>
                        </div>
                        <div class="seats seats-map">
                          <div class="row-wrapper">
                            <ul class="seat-row" v-for="rows in data.seats.seats">
                              <li v-for="seat in rows" v-if="seat.id"
                                  :class="[seat.taken ? 'taken' : 'available', 'seat-area-' + seat.category.id, 'seat-size-' + seat.size, seat.picked ? 'selected' : '', seat.group !== null ? 'seat-group' : '', seat.index % 2 === 0 ? 'seat-odd' : 'seat-even' ]"
                                  v-on:click="seatPicker(seat)">
                                {{ seat.name }}
                              </li>
                              <li class="spacer" v-else></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="legend mt-4">
                    <div v-for="category in data.seats.categories">
                      <span :class="'seat-area-' + category.id"></span>
                      <p>{{ category.name }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="ticketing-step-1" v-if="step === 2">
              <div class="ticketing-content">
                <div class="card">
                  <div class="table-responsive">
                    <table class="table table-nowrap card-table">
                      <thead>
                      <tr>
                        <th>Combo</th>
                        <th class="text-right">Giá tiền</th>
                        <th class="text-right">Số lượng</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr class="ticketing-concession-type" v-for="concession in data.concessions">
                        <td class="concession-name">
                          {{ concession.name }}
                          <span class="text-muted d-block"
                                v-if="concession.description !== concession.name">{{ concession.description }}</span>
                        </td>
                        <td class="concession-price text-right">
                          {{
                            new Intl.NumberFormat('vi-VN', {
                              style: 'currency',
                              currency: 'VND'
                            }).format(concession.price)
                          }}
                        </td>
                        <td class="ticketing-select text-right">
                          <div class="quantity-toggle">
                            <a class="btn btn-sm btn-rounded-circle btn-white"
                               :class="{ 'disabled': concession.quantity === 0 }"
                               v-on:click="concessionPicker(concession, 'remove')">-</a>
                            <input type="text" min="0" max="10"
                                   class="form-control form-control-flush text-dark text-center d-inline"
                                   :value="concession.quantity" style="width: 30px;" readonly>
                            <a class="btn btn-sm btn-rounded-circle btn-white"
                               :class="{ 'disabled': concession.quantity === 10 }"
                               v-on:click="concessionPicker(concession, 'add')">+</a>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div id="ticketing-step-0" v-if="step === 3">
              <div class="text-center">
                <div class="spinner-border d-block m-auto" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {bindStickyBar} from '../dependencies/sticky-bar';
import {initAmplitude, trackBookingEvent} from '../dependencies/amplitude';
import BootstrapDialog from '../../theme/js/bootstrap-dialog.min.js'

export default {
  name: 'Booking',
  props: [
    'showtimeId',
    'showtime'
  ],
  created() {
    this.getShowtime()
    this.getSeats()
    this.getConcessions()
    this.getOrder()
  },
  mounted() {
    initAmplitude()
    trackBookingEvent('Ticketing Flow Initiated', this.data.showtime)
    setTimeout(function () {
      bindStickyBar()
    }, 500)
  },
  data() {
    return {
      step: 1,
      data: {
        order: {},
        showtime: {},
        seats: {
          rows: [],
          categories: [],
          seats: [],
          groups: [],
        },
        concessions: [],
        ready: false,
      },
      cart: {
        seats: [],
        concessions: []
      },
      order: {
        id: null,
        total: 0
      },
      errors: []
    }
  },
  methods: {
    stepHandler(action) {
      if (action === 'next') {
        if (this.step <= 2) {
          this.step++;
        }

        // handle when concession is empty
        if (this.step === 2 && this.data.concessions.length === 0) {
          this.stepHandler('next')
        }

        if (this.step === 3) {
          this.createOrder()
        }
      } else {
        if (this.step > 0) {
          this.step--;
        }

        // handle when concession is empty
        if (this.step === 2 && this.data.concessions.length === 0) {
          this.stepHandler('prev')
        }
      }
    },
    getShowtime() {
      this.data.showtime = JSON.parse(this.showtime)
    },
    getSeats() {
      axios.get('/booking/' + this.showtimeId + '/seats')
          .then(r => {
            this.data.seats.rows = r.data.rows
            this.data.seats.categories = r.data.categories

            let seats = []
            let groups = []
            r.data.seats.forEach(function (rows, rowIndex) {
              seats[rowIndex] = []
              let seatIndex = 0
              rows.forEach(function (seat) {
                if (seat.id) {
                  // handle couple seat as group
                  let groupIndex = null
                  if (seat.category.couple === true && seat.size === 1) {
                    groupIndex = Math.floor(seatIndex / 2)
                    groupIndex = '' + rowIndex + groupIndex;
                  }

                  seat = {
                    ...seat,
                    ...{picked: false, group: groupIndex, index: seatIndex}
                  }

                  // handle couple seat as group
                  if (seat.group !== null) {
                    if (groups[groupIndex] === undefined) {
                      groups[groupIndex] = []
                    }

                    groups[groupIndex].push(seat)
                  }

                  seatIndex++
                }

                seats[rowIndex].push(seat)
              })
            })

            this.data.seats.seats = seats
            this.data.seats.groups = groups
          })
          .finally(() => {
            this.data.ready = true
            trackBookingEvent('Ticketing Seat Loaded', this.data.showtime)
          })
          .catch(e => {
            if (e?.response?.status === 400) {
              this.errors.push('Không tải được dữ liệu ghế do suất chiếu không khả dụng hoặc đã quá thời gian')
              trackBookingEvent('Ticketing Seat Load Expired', this.data.showtime)
            } else {
              this.errors.push('Không tải được dữ liệu ghế do có lỗi từ hệ thống đối tác')
              trackBookingEvent('Ticketing Seat Load Failed', this.data.showtime)
            }

          });
    },
    getConcessions() {
      axios.get('/booking/' + this.showtimeId + '/concessions')
          .then(r => {
            this.data.concessions = r.data.map((item) => {
              return {
                ...item,
                ...{quantity: 0}
              }
            })
          })
          .catch(e => {

          });
    },
    getOrder() {
      let params = new URLSearchParams(window.location.search);
      let orderId = params.get('orderId')
      if (orderId !== null) {
        axios.get('/booking/orders/' + orderId)
            .then(r => {
              this.data.order = r.data
            })
            .catch(e => {

            });
      }
    },
    createOrder() {
      this.step = 3

      let payload = {
        seats: [],
        concessions: [],
        contact: null
      }
      this.cart.seats.forEach(function (seat) {
        payload.seats.push({
          id: seat.id,
          name: seat.name,
          price: seat.price,
          category: {
            id: seat.category.id,
            name: seat.category.name,
            couple: seat.category.couple,
          }
        })
      })

      this.cart.concessions.forEach(function (concession) {
        if (concession.quantity > 0) {
          payload.concessions.push({
            id: concession.id,
            name: concession.name,
            price: concession.price,
            quantity: concession.quantity,
          })
        }
      })

      if (typeof this.data.order.id !== 'undefined') {
        payload.contact = this.data.order.contact
      }

      axios.post('/booking/' + this.showtimeId + '/orders', payload)
          .then(r => {
            this.order.id = r.data.id
            trackBookingEvent('Ticketing Order Created', this.data.showtime, {
              order_id: r.data.id,
              order_status: r.data.status,
              order_amount: r.data.amount,
              order_surcharge: r.data.surcharge
            }, true)
            // temporary put here until https://moveek.atlassian.net/browse/MVK-1119
            trackBookingEvent('Ticketing Checkout Initiated', this.data.showtime, {}, true)
            window.location = '/thanh-toan/' + r.data.id
          })
          .catch(e => {
            this.errors.push('Không thể tạo đơn hàng do lỗi chưa xác định')
            trackBookingEvent('Ticketing Order Create Failed', this.data.showtime)
          });
    },
    seatPicker(seat) {
      if (seat.taken) {
        return
      }

      if (seat.group !== null) {
        this.seatGroupPicker(seat.group)
      } else {
        this.seatSinglePicker(seat)
      }
    },
    seatSinglePicker(seat) {
      let maxSeats = this.data.showtime.cinema.adapter === 'beta' ? 8 : 10
      let index = this.getPickedSeatIndex(seat)
      if (index === null) { // not picked
        // handle max seats pick
        if (this.cart.seats.length >= maxSeats) {
          this.showModal(
              'Chỉ cho phép đặt tối đa ' + maxSeats + ' ghế trong 1 lần đặt vé.',
              'Đóng'
          )

          return
        }

        seat.picked = true
        this.cart.seats.push(seat);
      } else {
        seat.picked = false
        this.cart.seats.splice(index, 1);
      }
    },
    seatGroupPicker(groupIndex) {
      this.data.seats.groups[groupIndex].forEach(seat => {
        this.seatSinglePicker(seat)
      })
    },
    getPickedSeatIndex(seat) {
      let index = null
      this.cart.seats.forEach(function (s, i) {
        if (s.id === seat.id) {
          index = i
        }
      })

      return index
    },
    concessionPicker(concession, action, quantity = 1) {
      if (action === 'add') {
        concession.quantity = concession.quantity + quantity
      } else {
        concession.quantity = concession.quantity - quantity
      }

      let index = this.getPickedConcessionIndex(concession)
      if (index === null && concession.quantity > 0) {
        this.cart.concessions.push(concession);
      }

      if (index !== null && concession.quantity === 0) {
        this.cart.concessions.splice(index, 1);
      }
    },
    getPickedConcessionIndex(concession) {
      let index = null
      this.cart.concessions.forEach(function (c, i) {
        if (c.id === concession.id) {
          index = i
        }
      })

      return index
    },
    calculateCartTotal() {
      let total = 0
      this.cart.seats.forEach(function (seat) {
        total += seat.price
      })

      this.cart.concessions.forEach(function (concession) {
        total += concession.price * concession.quantity
      })

      this.order.total = total
    },
    showModal(message, buttonLabel) {
      let dialog = BootstrapDialog.show({
        type: BootstrapDialog.TYPE_LIGHT,
        closable: false,
        message: message,
        buttons: [{
          cssClass: 'btn-dark',
          label: buttonLabel,
          action: function (dialog) {
            dialog.close();
          }
        }]
      })
      dialog.getModalHeader().hide()
    },
    isDeluxeRoom() {
      return (this.data.showtime.cinema.adapter === 'dcine'
              && this.data.showtime.cinema.slug === 'dcine-ben-thanh'
              && this.data.showtime.room === '03')
          || (this.data.showtime.cinema.adapter === 'starlight'
              && this.data.showtime.room.startsWith('GOLD'))
    }
  },
  watch: {
    cart: {
      handler: function () {
        this.calculateCartTotal()
      },
      deep: true
    },
    'data.showtime': {
      handler: function () {
        let message
        let showtime = new Date(this.data.showtime.time)

        if (['P', 'K', 'T13'].includes(this.data.showtime.movie.mpaa) && showtime.getHours() >= 20) {
          message = 'Theo quy định của Bộ Văn Hóa, Thể Thao và Du Lịch: Rạp phim không được phép phục vụ khách hàng <strong>dưới 13 tuổi</strong> cho các suất chiếu kết thúc <strong>sau 22:00</strong> và <strong>dưới 16 tuổi</strong> cho các suất chiếu kết thúc <strong>sau 23:00</strong>. Rạp sẽ không hoàn tiền nếu người xem không đáp ứng đủ điều kiện.'
        } else {
          switch (this.data.showtime.movie.mpaa) {
            case 'K':
              message = 'Theo quy định của cục điện ảnh, phim dành cho khán giả có <strong>người bảo hộ đi kèm</strong>. Hãy cân nhắc trước khi tiếp tục.'
              break;
            case 'T13':
              message = 'Theo quy định của cục điện ảnh, phim không dành cho khán giả <strong>dưới 13 tuổi</strong>. Hãy cân nhắc trước khi tiếp tục.'
              break;
            case 'T16':
              message = 'Theo quy định của cục điện ảnh, phim không dành cho khán giả <strong>dưới 16 tuổi</strong>. Hãy cân nhắc trước khi tiếp tục.'
              break;
            case 'T18':
              message = 'Theo quy định của cục điện ảnh, phim không dành cho khán giả <strong>dưới 18 tuổi</strong>. Hãy cân nhắc trước khi tiếp tục.'
              break;
            default:
              message = null
          }
        }

        if (message !== null) {
          this.showModal(message, 'Tôi đã hiểu và đồng ý')
        }

        if (this.isDeluxeRoom()) {
          this.showModal('Mỗi vé đã bao gồm <strong>01</strong> phần combo bắp nước.', 'Tôi đã hiểu và đồng ý')
        }
      },
    },
    'data.ready': {
      handler: function () {
        // workaround until we upgrade to vuejs 3
        setTimeout(() => {
          if (this.data.ready === true && this.data.order.id) {
            let seats = []
            this.data.order?.seats.forEach(seat => {
              seats.push(seat.id)
            })

            this.data.seats.seats.forEach(rows => {
              rows.forEach(seat => {
                if (seats.includes(seat.id)) {
                  this.seatPicker(seat)
                }
              })
            })

            let concessions = []
            this.data.order?.concessions.forEach(concession => {
              concessions[concession.id] = concession.quantity
            })

            this.data.concessions.forEach(concession => {
              if (concession.id in concessions) {
                this.concessionPicker(concession, 'add', concessions[concession.id].quantity)
              }
            })
          }
        }, 1000)
      },
    }
  }
}
</script>

<style scoped>
</style>